import { FC, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { CaseListingType, RenderNextStepProps, statetype } from "./types";
import { PrecertAPIResponse } from "../precert/types";
import useAppealButtonFunc from "src/hooks/useAppealButtonFunc";

const RenderNextStep: FC<RenderNextStepProps> = ({ kase, showHideModalForTreatment, setDataForTreatmentDecisionModal }): JSX.Element => {

  const navigate = useNavigate();
  const [precertPathParameters, setPrecertPathParameters] = useState<statetype>()
  const { apiInPorgress } = useAppealButtonFunc();

  let precertButtons;
  let updateButtons;
  let reviewButtons;
  let rx_pa_buttons;
  let review_pa_button;
  let update_pa_button;

  const { mutate: fetchPrecertMutate, data: fetchPrecertResponse } =
    useFetch<PrecertAPIResponse>(APIEndpoints.FETCH_PRECERT, {}, {}, false);

  useEffect(() => {
    if (fetchPrecertResponse) {
      navigate(`/cases/${precertPathParameters && precertPathParameters.case_id}/precerts/${precertPathParameters && precertPathParameters.id}/edit?insuranceName=${precertPathParameters && precertPathParameters.insurance_name}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchPrecertResponse]);
  const navigateToPrecertForm = (caseId: number, precertId: number ,insuranceName:string) => {
    const pathParams = {
      case_id: caseId,
      id: precertId
    }
    setPrecertPathParameters(pathParams)
    fetchPrecertMutate({}, pathParams)
    let pathParam = {insurance_name:insuranceName, ...pathParams}
    setPrecertPathParameters(pathParam)
  }
  const navigateToUpdatePrecertForm = (caseId: number, precertId: number, patient: string,insurance_name: string) => {
    navigate(`/cases/${caseId}/precert/${precertId}/edit?patient=${patient}&insuranceName=${insurance_name}`);
  }
  const navigateToReviewPrecertForm = (caseId: number, precertId: number, title: string, patient: string,insurance_name: string) => {
    navigate(`/cases/${caseId}/precerts/${precertId}/review?title=${title + " " + caseId}&precert_id=${precertId}&patient=${patient}&insuranceName=${insurance_name}`,
    );
  }
  const navigateToReviewRXPrecertForm = (caseId: number, precertId: number, title: string, patient: string,insurance_name: string) => {
    navigate(`/cases/${caseId}/prior_authorizations/${precertId}?title=${title + " " + caseId}&precert_id=${precertId}&patient=${patient}&insuranceName=${insurance_name}`, {
      state: { title: title + " " + caseId, precert_id: precertId, patient: patient }
    });
  }
  const naviagteToRX_PA = (kase: CaseListingType,precert_id:number,insurance_name:string) => {
    navigate(`/cases/${kase.id}/documents/new?precert_id=${precert_id}&insuranceName=${insurance_name}`)
  }
  const naviagteToUpdateRX_PA = (kase: CaseListingType,precert_id:number,insurance_name:string) => {
    //priorAuthorization
    navigate(`/cases/${kase.id}/prior_authorizations/${precert_id}/edit?precert_id=${precert_id}&patient=${kase.patient.firstlastname}&insuranceName=${insurance_name}`, {
      state: { precert_id: kase.precert_id, patient: kase.patient.firstlastname }
    })

  }

  const caseAction = [];

  if (kase && kase.precert_buttons && kase.precert_buttons.length > 0) {
    precertButtons = kase.precert_buttons.map((btn) =>
      btn.precert === true &&
      <button
        className="btn btn-warning btn-sm m-1"
        key={`review-${btn.key}`}
        data-bs-toggle="tooltip"
        data-bs-placement="right"
        title={`${btn.ins_name}`}
        onClick={() => { btn.precert_id && navigateToPrecertForm(kase.id, btn.precert_id,btn.ins_name) }}
      >Precert
      </button>
    );
  }
  if (kase && kase.update_buttons && kase.update_buttons.length > 0) {
    updateButtons = kase.update_buttons.map((btn) =>
      btn.update === true &&
      <button
        className="btn btn-warning btn-sm m-1"
        key={`review-${btn.key}`}
        data-bs-toggle="tooltip"
        data-bs-placement="right"
        title={`${btn.ins_name}`}
        disabled={apiInPorgress}
        onClick={() => { btn.precert_status === 'submitted' ? btn?.precert_id && navigateToUpdatePrecertForm(kase.id, btn.precert_id, kase.patient.firstlastname,btn.ins_name) : btn?.precert_id && navigateToPrecertForm(kase.id, btn.precert_id,btn.ins_name) }}
      >Update PA
      </button>

    );
  }
  if (kase && kase.review_buttons && kase.review_buttons.length > 0) {

    reviewButtons = kase.review_buttons.map((btn) =>
      btn.review === true &&
      <button
        className="btn btn-warning btn-sm m-1"
        key={`review-${btn.key}`}
        data-bs-toggle="tooltip"
        data-bs-placement="right"
        title={`${btn.ins_name}`}
        onClick={() => { btn.precert_id && navigateToReviewPrecertForm(kase.id, btn.precert_id, "Review Med PA For Case", kase.patient.firstlastname,btn.ins_name) }}
      >Review PA
      </button>

    );

  }
  if (kase && kase.rx_pa_buttons && kase.rx_pa_buttons.length > 0) {
    rx_pa_buttons = kase.rx_pa_buttons.map((btn) =>
      btn.rx_pa === true &&
      <button className="btn btn-warning btn-sm m-1 text-nowrap"
        disabled={apiInPorgress}
        key={`review-${btn.key}`}
        data-bs-toggle="tooltip"
        data-bs-placement="right"
        title={`${btn.ins_name}`}
        onClick={() => naviagteToRX_PA(kase,btn.prior_authorization_id,btn.ins_name)}
      >RX PA
      </button>
    );
  }
  if (kase && kase.review_pa_buttons && kase.review_pa_buttons.length > 0) {
    review_pa_button = kase.review_pa_buttons.map((btn) =>
      btn.review_pa === true &&
      <button className="btn btn-warning btn-sm m-1"
      key={`review-${btn.key}`}
      data-bs-toggle="tooltip"
      data-bs-placement="right"
      title={`${btn.ins_name}`}
        disabled={apiInPorgress}
        onClick={() => btn.prior_authorization_id && navigateToReviewRXPrecertForm(kase.id, btn.prior_authorization_id, "Review RX PA For Case", kase.patient.firstlastname,btn.ins_name)}
      >Review RX PA
      </button>
    );
  }
  if (kase && kase.update_pa_buttons && kase.update_pa_buttons.length > 0) {
    update_pa_button = kase.update_pa_buttons.map((btn) =>
      btn.update_pa === true &&
      <button className="btn btn-warning btn-sm m-1 text-nowrap"
        disabled={apiInPorgress}
        key={`review-${btn.key}`}
        data-bs-toggle="tooltip"
        data-bs-placement="right"
        title={`${btn.ins_name}`}
        onClick={() => naviagteToUpdateRX_PA(kase,btn.prior_authorization_id,btn.ins_name)}
      >Update RX PA
      </button>
    );
  }

  if (kase.status_name.toLowerCase() !== "cancelled") {
    if (kase.date_of_treatment && kase.no_action_required) {
      caseAction.push(
        <button
          className="btn btn-success btn-sm m-1"
          onClick={() => showHideModalForTreatment({ isModalVisible: true, caseId: kase.id, prescriptionId: kase.prescription_id })}
        >
          Date of Treatment
        </button>)
    }
    if (kase.treatment_decision) {
      caseAction.push(
        <button className="btn btn-primary btn-sm m-1 text-nowrap" disabled={apiInPorgress}
          onClick={() => setDataForTreatmentDecisionModal({ isModalVisible: true, caseId: kase.id, prescriptionId: kase.prescription_id, prior_authorization_id: kase.prior_auth_id ? kase.prior_auth_id : 0, prior_auth_status: '',kase:kase })}
        >
          <span title="Click here to transfer to pharmacy or indicate treatment decision" data-bs-toggle="tooltip"
            data-bs-placement="right"
          >Treatment Decision
          </span>
        </button>
      )
    }

    if (kase.copay_claim) {
      caseAction.push(
        <Link to={`/cases/${kase.id}/copay`} className="btn btn-copay">Copay Claim</Link>
      )
    }
    if(kase.no_action_required){
      caseAction.push(<p className="mb-0">No Action Required</p>);
    }
  }

  return (
    <>
      {caseAction}
      {precertButtons}
      {reviewButtons}
      {updateButtons}
      {rx_pa_buttons}
      {update_pa_button}
      {review_pa_button}
    </>
  );
};

export default RenderNextStep;
